export { getStaticPropsCreditCardsPage } from './lib'
export { CreditCardsPage } from './ui'
